import React from "react";
import styles from "./Faq.module.scss";

interface FaqProps {
  question: string;
  answer: string;
  number?: number;
  isOpen: boolean; // Чи питання відкрите
  onToggle: () => void; // Функція для відкриття/закриття
  description?: string;
}

const Faq: React.FC<FaqProps> = ({
  question,
  answer,
  number,
  isOpen,
  onToggle,
  description,
}) => {
  return (
    <div className={styles.faqItem}>
      <div className={styles.question} onClick={onToggle}>
        {number && <span className={styles.number}>{number} </span>}
        <h4>{question}</h4>
        <div>
          {description && <p className={styles.description}>{description}</p>}
        </div>
        <svg
          className={`${styles.arrow} ${isOpen ? styles.open : ""}`}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          aria-hidden="true"
        >
          <path
            fill="#888"
            fillRule="evenodd"
            d="M4.293 19.707a1 1 0 0 0 1.414 0l10-10a1 1 0 0 0-1.414-1.414l-10 10a1 1 0 0 0 0 1.414ZM18 6v13a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h13Z"
            clipRule="evenodd"
          ></path>
        </svg>
      </div>
      {isOpen && (
        <div
          className={styles.answer}
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      )}
    </div>
  );
};

export default Faq;
